import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import { useAuth } from '../hooks';
// routes
import { PATH_DASHBOARD } from '../routes/paths';
// components
import { LoadingScreen } from '../components/loading';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
    const { isAuthenticated, isInitialized } = useAuth();
    const { search } = useLocation();

    const defaultRoute = search?.trim()?.split('?next=');

    const rawNext = defaultRoute.length > 1 ? defaultRoute[1] : '';
    // Same-origin guard: only relative paths ('/foo') are safe. '//' is treated as a
    // protocol-relative URL by browsers and can redirect off-domain (open redirect).
    const SearchQuery = rawNext.startsWith('/') && !rawNext.startsWith('//') ? rawNext : '';

    if (isAuthenticated) {
        return <Navigate to={SearchQuery || PATH_DASHBOARD.root } />;
    }

    if (!isInitialized) {
        return <LoadingScreen />;
    }

    return <>{children}</>;
}

GuestGuard.propTypes = {
    children: PropTypes.node,
};